import { grey, green } from '@mui/material/colors';

const validatedColor = (color) => (/^#([0-9A-Fa-f]{3}){1,2}$/.test(color) ? color : null);

const tailWindGray = {
  50: '#f9fafb',
  100: '#f3f4f6',
  200: '#e5e7eb',
  300: '#d1d5db',
  400: '#9ca3af',
  500: '#6b7280',
  600: '#4b5563',
  700: '#374151',
  800: '#1f2937',
  900: '#111827',
}

const primary = {
  50: '#FFF5F2', 100: '#FFF1EE', 200: '#FFE4DE', 300: '#FFD5CC',
  400: '#FFBCAD', 500: '#FE795D', 600: '#EF562F', 700: '#EB4F27',
  800: '#CC4522', 900: '#A5371B'
}

export default (server, darkMode) => {
  const revenda = server?.revenda;

  const primaryColor = validatedColor(
    revenda?.colors?.primary ||
    server?.attributes?.colorPrimary
  );

  const secondaryColor = validatedColor(
    revenda?.colors?.success ||
    server?.attributes?.colorSecondary
  );

  return {
    mode: darkMode ? 'dark' : 'light',
    background: {
      default: darkMode ? tailWindGray['900'] : grey[50],
      paper: darkMode ? tailWindGray[800] : tailWindGray[100],
    },
    primary: {
      main: primaryColor || (darkMode ? primary[50] : primary[900]),
    },
    secondary: {
      main: secondaryColor || (darkMode ? green[200] : green[800]),
    },
    neutral: {
      main: grey[500],
      icon3d: primary[400]
    },
    geometry: {
      main: '#3bb2d0',
    },
    alwaysDark: {
      main: grey[900],
    }
  };
};